import { capitalize } from '@material-ui/core';
import style from './PanelDetailOrder.module.scss';
import React, { useEffect } from 'react';
import i18n from 'i18n';
import orderTypeIcon from "assets/images/order-type-icon.png";
import orderOwnerIcon from "assets/images/order-owner-icon.png";
import orderReasonIcon from "assets/images/order-reason-icon.png";
import orderNumberIcon from "assets/images/order-number-icon.png";
import recTypeMapping from "../../../../../views/Admin/Orders/RecOrders/data/RecTypeMapping";


const PanelDetailOrder = ({ order }) => {

    const [data, setData] = React.useState()

    useEffect(() => {

        let data = [
            {
                title: capitalize(i18n.t("order.type")).toUpperCase(),
                value: recTypeMapping[order.klass] || order.klass,
                icon: orderReasonIcon,
            },
            {
                title: capitalize(i18n.t("reason")).toUpperCase(),
                value:  recTypeMapping[order.klass] || order.klass,
                icon: orderTypeIcon,
            },
            {
                title: capitalize(i18n.t("order.number")).toUpperCase(),
                value: order.code,
                icon: orderNumberIcon,
            },
            {
                title: capitalize(i18n.t("owner")).toUpperCase(),
                value: order.owner ? order.owner.first_name : "",
                icon:   orderOwnerIcon,
            },

        ]
        setData(data);

    }, [order]);


    return (
        <div className={style['panel-detail-order']}>
            {data && data.map((item, index) => {
                return (
                    <div key={index} className={style['panel-detail-cell']}>
                        <div >
                            <img src={item.icon} alt={item.title} className={style['panel-detail-order-icon']} />
                        </div>
                        <div className={style["panel-detail-order-data"]}>
                            <div className={style['panel-detail-order-data-title']}>{item.title}</div>
                            <div className={style['panel-detail-order-data-value']}>{item.value}</div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default PanelDetailOrder;